export const ScheduleType = {
    onetime: 'onetime',
    recurring: 'recurring',
    tiff: 'tiff',
};

export const ExchangeType = {
    custom: 'custom',
    reallocation: 'reallocation',
    fromTIFF: 'fromTIFF',
    intoTIFF: 'intoTIFF',
};

export const AllocationType = {
    dollar: 'dollar',
    unit: 'unit',
    percentage: 'percentage',
};

export const Frequency = {
    quaterly: 'Quarterly',
    monthly: 'Monthly',
    weekly: 'Weekly',
}

export const ContactUsNumber = '888-383-4483';

export const ContactUsEmail='questions@vanguardcharitable.org';

export const ExchangesMinLimit = Number(2);

export const ExchangesMaxLimit = Number(99);

export const DateFormat = 'MM/DD/YYYY';

export const DateTimeFormat = 'MM/DD/YYYY hh:mm A';

export const APIDateFormat = 'YYYY-MM-DD';

export const isTIFF = (name) => Boolean(name && name.toLowerCase() === 'tiff multi-asset pool');

export const EditExchangeDetailStatuses = ['entered', 'active'];

export const NoEditSpawnStatuses = ['exchange completed', 'cancelled', 'approved'];

export const ViewSpawnOnStatuses = ['exchange completed', 'approved'];

export const BlockRecommendAnExchange = [
    "Excessive exchanges - block exchanges".toLowerCase(),
    "Other - block all transactions except contributions".toLowerCase(),
    "Block all transactions, including contributions".toLowerCase(),
    "10 Day - Block All Transactions".toLowerCase(),
    "Written Request - Block All Transactions".toLowerCase(),
    "Written Request - Block Grants and Transfers".toLowerCase(),
    "Legal - Block All Transactions".toLowerCase(),
    "Other - Block All Transactions".toLowerCase(),
];
